import i18n from "@/plugins/i18n.js";
import { generalAxios } from "@/plugins/axios";
import Antd from "ant-design-vue";

export default {
  // START:: GET NOTIFICATIONS
  async getNotificationCount(context) {
    try {
      let res = await generalAxios({
        method: "GET",
        url: "notifications/unread-count",
        params: {
          per_page: 1,
        },
      });
      console.log("Notification count raw response:", res);
      console.log("Notification count response:", res.data.unread_count);
      context.commit("setNotificationCount", res.data.unread_count || 0);
    } catch (err) {
      console.error(
        "Error getting notification count:",
        err.response?.data || err.message
      );
    }
  },
  getNotifications(context) {
    // START:: SEND GET REQUEST
    generalAxios({
      method: "GET",
      url: "notifications/unread-count",
      params: {
        unread: 1,
      },
    })
      .then((res) => {
        console.log("Unread notifications response:", res.data.unread_count);
        context.commit("setNotifications", {
          unreadNotificationsCount: res.data.unread_count || 0,
          notifications: res.data.data,
        });
      })
      .catch((error) => {
        console.error(
          "Error getting notifications:",
          error.response?.data || error.message
        );
      });
    // END:: SEND GET REQUEST
  },
  // END:: GET NOTIFICATIONS

  // START:: READ SINGLE NOTIFICATION
  readSingleNotification(context, payload) {
    // START:: SEND GET REQUEST
    generalAxios({
      method: "POST",
      url: `notification/${payload}/read`,
    })
      .then(() => {
        context.dispatch("getNotifications");
      })
      .catch((error) => {
        console.log(error.response.data.message);
      });
    // END:: SEND GET REQUEST
  },
  // END:: READ SINGLE NOTIFICATION

  // START:: READ ALL NOTIFICATIONS
  readAllNotifications(context) {
    // START:: SEND GET REQUEST
    generalAxios({
      method: "GET",
      url: "notifications",
    })
      .then((res) => {
        context.commit("setAllReadiedNotifications", {
          unreadNotificationsCount: 0,
          notifications: res.data.data,
        });
      })
      .catch((error) => {
        console.log(error.response.data.message);
      });
    // END:: SEND GET REQUEST
  },
  // END:: READ ALL NOTIFICATIONS

  // START:: DELETE NOTIFICATION
  deleteNotification(context, payload) {
    // START:: SEND GET REQUEST
    generalAxios({
      method: "DELETE",
      url: `notifications/${payload.id}`,
    }).then(() => {
      if (payload.notificationType == "readied_notification") {
        context.dispatch("readAllNotifications");
      } else {
        context.dispatch("getNotifications");
      }
      Antd.message.success(i18n.t("MESSAGES.deletedSuccessfully"));
    });
    // END:: SEND GET REQUEST
  },
  // END:: DELETE NOTIFICATION

  // START:: DELETE ALL NOTIFICATION
  deleteAllNotifications(context) {
    // START:: SEND GET REQUEST
    generalAxios({
      method: "DELETE",
      url: "notifications",
    }).then(() => {
      context.dispatch("getNotifications");
      Antd.message.success(i18n.t("MESSAGES.deletedSuccessfully"));
    });
    // END:: SEND GET REQUEST
  },
  // END:: DELETE ALL NOTIFICATION
};
